// @ts-check
import { defineConfig } from '../utils';

export function auctions() {
  return defineConfig({
    properties: {
      'GestionSubasta.ActivarTecladoEnDatosConLecturaDeCodigosDeBarras': {
        defaultValue: false,
      },
    },
  });
}
